import { BroadcastChannel } from 'broadcast-channel';

import { SIZE_INFO_CHANNEL } from './constants';
import { SizeInfoChannelMessage } from './types';
import { isSizeInfoChannelMessage } from './validators';

/**
 * 채널 인스턴스와 리스너를 관리하는 싱글톤 객체
 */
export const channelManager = {
  channel: null as BroadcastChannel | null,
  listeners: new Set<(message: SizeInfoChannelMessage) => void>(),

  init() {
    if (this.channel) return;
    try {
      this.channel = new BroadcastChannel(SIZE_INFO_CHANNEL);
      this.channel.onmessage = (event) => {
        try {
          const data = typeof event === 'string' ? JSON.parse(event) : event;
          if (isSizeInfoChannelMessage(data)) {
            this.listeners.forEach((listener) => listener(data));
          }
        } catch (e) {
          console.warn('[SizeInfo] BroadcastChannel parse failed', e);
        }
      };
    } catch (e) {
      console.warn('[SizeInfo] BroadcastChannel init failed', e);
    }
  },

  subscribe(listener: (message: SizeInfoChannelMessage) => void) {
    this.listeners.add(listener);
    if (!this.channel) {
      this.init();
    }

    return () => {
      this.listeners.delete(listener);
      // 더 이상 구독자가 없으면 채널을 닫아 리소스 해제
      if (this.listeners.size === 0 && this.channel) {
        this.channel.close();
        this.channel = null;
      }
    };
  },

  async send(message: SizeInfoChannelMessage) {
    try {
      if (this.channel) {
        await this.channel.postMessage(message);
        this.listeners.forEach((listener) => listener(message));
      } else {
        const tempChannel = new BroadcastChannel(SIZE_INFO_CHANNEL);
        await tempChannel.postMessage(message);
        await tempChannel.close();
      }
    } catch (e) {
      console.warn('[SizeInfo] BroadcastChannel send failed', e);
    }
  },
};
